import React, { Component } from "react";
import PropTypes from "prop-types";
import { DragSource, DropTarget } from "react-dnd";
import { Button } from "material-ui";
import EditIcon from "material-ui-icons/ModeEdit";
import RemoveIcon from "assets/images/remove.png";
import ItemTypes from "./ItemTypes";

const itemSource = {
  beginDrag(props) {
    return {
      id: props.id,
      originalIndex: props.findAttr(props.id).index
    };
  },

  endDrag(props, monitor) {
    const { id: droppedId, originalIndex } = monitor.getItem();
    const didDrop = monitor.didDrop();
    if (!didDrop) {
      props.moveAttr(droppedId, originalIndex);
    }
  }
};

const itemTarget = {
  canDrop() {
    return false;
  },

  hover(props, monitor) {
    const { id: draggedId } = monitor.getItem();
    const { id: overId } = props;

    if (draggedId !== overId) {
      const { index: overIndex } = props.findAttr(overId);
      props.moveAttr(draggedId, overIndex);
    }
  }
};

const dropTarget = connect => ({
  connectDropTarget: connect.dropTarget()
});
const dragSource = (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging()
});

class Attr extends Component {
  render() {
    const {
      id,
      title,
      index,
      attrItemLabels,
      isDragging,
      connectDragSource,
      connectDropTarget,
      openModal,
      removeAttr,
      preset
    } = this.props;
    const opacity = isDragging ? 0.3 : 1;
    return connectDragSource(
      connectDropTarget(
        <div
          id={id}
          tabIndex={id}
          style={{
            padding: "0.5rem 1rem",
            border: "1px dashed gray",
            marginBottom: ".5rem",
            backgroundColor: "white",
            cursor: "move",
            outline: "none",
            opacity,
            display: "inline-flex",
            alignItems: "center"
          }}
        >
          <div style={{ marginLeft: 20, width: 30 }}>{index}</div>
          <div style={{ marginLeft: 20, width: 200 }}>{title}</div>
          <div style={{ marginLeft: 20, width: 524 }}>{attrItemLabels}</div>
          <div style={{ width: 54 }}>
            <Button
              dense
              raised
              style={{
                marginLeft: 15,
                minWidth: 40
              }}
              onClick={() => openModal(id)}
            >
              <EditIcon style={{ height: 20, width: 20 }} />
            </Button>
          </div>
          <div style={{ width: 54 }}>
            {!preset && (
              <Button
                dense
                raised
                style={{
                  marginLeft: 15,
                  minWidth: 40
                }}
                onClick={() => removeAttr(index - 1)}
              >
                <img
                  style={{ height: 20, width: 20 }}
                  alt="remove"
                  src={RemoveIcon}
                />
              </Button>
            )}
          </div>
        </div>
      )
    );
  }
}

Attr.propTypes = {
  connectDragSource: PropTypes.func.isRequired,
  connectDropTarget: PropTypes.func.isRequired,
  isDragging: PropTypes.bool.isRequired,
  id: PropTypes.any.isRequired,
  moveAttr: PropTypes.func.isRequired,
  findAttr: PropTypes.func.isRequired
};
export default DragSource(ItemTypes.ATTR, itemSource, dragSource)(
  DropTarget(ItemTypes.ATTR, itemTarget, dropTarget)(Attr)
);



// WEBPACK FOOTER //
// ./src/components/SetupAttr/Attr.jsx